/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { workloadIdentitiesListTokenEndpoints } from "../funcs/workloadIdentitiesListTokenEndpoints.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { WorkloadTokenEndpoints } from "../models/components/workloadtokenendpoints.js";
import {
  ListWorkloadTokenEndpointsRequest,
  ListWorkloadTokenEndpointsSecurity,
} from "../models/operations/listworkloadtokenendpoints.js";
import { unwrapAsync } from "../types/fp.js";
export type WorkloadTokenEndpointsQueryData = WorkloadTokenEndpoints;

export function prefetchWorkloadTokenEndpoints(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListWorkloadTokenEndpointsRequest | undefined,
  security?: ListWorkloadTokenEndpointsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildWorkloadTokenEndpointsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildWorkloadTokenEndpointsQuery(
  client$: GramCore,
  request?: ListWorkloadTokenEndpointsRequest | undefined,
  security?: ListWorkloadTokenEndpointsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<WorkloadTokenEndpointsQueryData>;
} {
  return {
    queryKey: queryKeyWorkloadTokenEndpoints({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function workloadTokenEndpointsQueryFn(
      ctx,
    ): Promise<WorkloadTokenEndpointsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(workloadIdentitiesListTokenEndpoints(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyWorkloadTokenEndpoints(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "workloadIdentities",
    "listTokenEndpoints",
    parameters,
  ];
}
